import { render, staticRenderFns } from "./CiServiceIcon.vue?vue&type=template&id=0906e496&scoped=true"
import script from "./CiServiceIcon.vue?vue&type=script&lang=js"
export * from "./CiServiceIcon.vue?vue&type=script&lang=js"
import style0 from "./CiServiceIcon.vue?vue&type=style&index=0&id=0906e496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906e496",
  null
  
)

export default component.exports